import React from 'react'
import PropTypes from 'prop-types'

export default function Transaction({ fill }) {
  return (
    <>
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="22"
      height="22"
      version="1.1"
      viewBox="0 0 48 48"
      xmlSpace="preserve"
    >
      <path
        fillRule="evenodd"
        d="M47 40a5 5 0 01-5 5H6a5 5 0 01-5-5V11a4 4 0 014-4h20.171l8.099-2.934a.99.99 0 011.268.589L35.391 7H39a4 4 0 014 4v2a4 4 0 014 4v23zM5 9a2 2 0 000 4h3.634c.013-.005.021-.016.034-.021L19.65 9H5zm29.078.181l-1.062-2.924h-.001L30.964 7h.003l-5.514 2h-.01l-11.039 4h21.062l-1.388-3.819zM41 11a2 2 0 00-2-2h-2.883l1.454 4H41v-2zm2 4H5c-.732 0-1.41-.211-2-.555V40a3 3 0 003 3h36a3 3 0 003-3v-7h-4a4 4 0 010-8h4v-8a2 2 0 00-2-2zm2 16v-4h-4a2 2 0 000 4h4zm-4-3h2v2h-2v-2z"
        clipRule="evenodd"
        fill={fill}
      ></path>
    </svg>
    </>
  )
}
Transaction.propTypes = {
  fill: PropTypes.string,
}
